import { Person, QueovalDate } from "../../models";

export class PipeCard {
  Ident: string;
  ClientId: string;
  Client: string;
  Title: string;
  Info: string;
  Categorie: string;
  Date: QueovalDate;
  Price: number;
  PricePonderation: number;
  Ponderation: number;
  Document: number;
  Priorite: string;
  NumDevis: string; 
  ContactId: string;
  Contact: string;
  ContactInfo: Person;

  CollaboName: string;
  CollaboId: string;
  CollaboAvatarUrl: string;

  HistoLastUpdate: QueovalDate;
  HistoNb: number;
  HistoNumberOfDaysInfo: string;
  HistoNumberOfDays: number;
  HistoLastInfo: string;

  DateBadgeColor: string;
  DateAbbreviation: string;

  StatusBadgeColor: string;
  Status: string;

  IsCloture: boolean;
  //Front variable
  IsDragging: boolean;
  Filtered: boolean;
}
